var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeOutError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 327,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H327V327H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000096",
    opacity: 0.05,
    cx: 163.5,
    cy: 163.5,
    r: 129.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#000096",
    strokeWidth: 4,
    opacity: 0.046,
    cx: 164,
    cy: 163.5,
    rx: 107,
    ry: 106.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.298 135.55c1.345-2.067 4.403-2.067 5.748 0l30.75 47.25c1.462 2.246-.17 5.2-2.874 5.2h-61.5c-2.703 0-4.336-2.954-2.874-5.2zm2.874 1.825l-30.75 47.25h61.5l-30.75-47.25zm0 37.125c1.887 0 3.417 1.511 3.417 3.375s-1.53 3.375-3.417 3.375c-1.887 0-3.416-1.511-3.416-3.375s1.53-3.375 3.416-3.375zm0-25.313c.839 0 1.536.597 1.681 1.385l.028.303v16.875c0 .932-.765 1.688-1.709 1.688a1.703 1.703 0 0 1-1.68-1.385l-.028-.303v-16.875c0-.932.765-1.688 1.708-1.688z",
    fill: "#000096"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeOutError);
export default __webpack_public_path__ + "static/media/time_out_error.c8b17ec13aa56bcbd5ac1c49a8f4144e.svg";
export { ForwardRef as ReactComponent };